export const createVendorApi = (api) => ({
  createVendor: (fpoId, data) => api.post(`/fpo/${fpoId}/vendor`, data),
  getVendors: (fpoId) => api.get(`/fpo/${fpoId}/vendor`),
  getVendorById: (fpoId, id) => api.get(`/fpo/${fpoId}/vendor/${id}`),
  updateVendor: (fpoId, id, data) => api.patch(`/fpo/${fpoId}/vendor/${id}`, data),
  deleteVendor: (fpoId, id) => api.delete(`/fpo/${fpoId}/vendor/${id}`),

  downloadVendor: (fpoId, vendorId = null, format = "pdf") => {
    const params = { format };
    if (vendorId) params.vendorId = vendorId;
    return api.get(`/fpo/${fpoId}/download`, { params, responseType: "blob" });
  },

  getVendorReport: (fpoId, params = {}) => api.get(`/fpo/${fpoId}/report`, { params }),
  dayBookDownloadByVendor: (fpoId, params = {}) =>
    api.get(`/fpo/${fpoId}/vendor/download`, { params, responseType: "blob" }),
  dayBookDownload: (fpoId, format = "pdf") =>
    api.get(`/fpo/${fpoId}/dayBook/download`, { params: { format }, responseType: "blob" }),
  getDayBookByFPOId: (fpoId) => api.get(`/fpo/${fpoId}/dayBook`),
});
